import { useSelector } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import { ApplicationState } from '../../../../../store';
import { CustomHeading, Link } from 'shared-components';
import Field from '../../../../Field/Field';
import { PrevNextButtons } from '../../../../PrevNextButtons';

import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { getApplicationData } from '@/components/pages/applicant-dashboard/sections/helpers/getApplicationData';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';

export default function PrivacyPolicy() {
  const { application } = useSelector((state: ApplicationState) => state.apply);
  const { applyConfig } = useSelector((state: ApplicationState) => state.applyConfig);

  const { initial, current } = getApplicationData(application);
  const { privacyPolicyConsent } = current;
  const { privacyPolicyConsent: initialPrivacyPolicyConsent } = initial;

  const { privacyPolicyUrl } = applyConfig;
  const navigate = useNavigate();
  const { nextRoute, previousRoute } = useTaskNavigation();

  const AcceptanceText = () => (
    <>
      <Text>
        I consent to the processing of sensitive data (e.g., health, ethnicity) to support my application and for
        monitoring purposes.
      </Text>
      <Text>
        The information provided will be used to assess your eligibility and progress your application, in accordance
        with our
        <Link href={privacyPolicyUrl} isExternal>
          Privacy Policy
        </Link>
        .
      </Text>
    </>
  );

  const RejectionText = () => <Text>This user has not accepted their privacy policy consent.</Text>;

  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <CustomHeading level="h1" flexGrow={1} mb={8}>
          Privacy policy
        </CustomHeading>

        <CustomHeading level="h2" mb={2} mt={6} fontSize="md">
          Data
        </CustomHeading>

        <Box>
          {(privacyPolicyConsent || initialPrivacyPolicyConsent) && (
            <Field
              leftLabel="Agreed to"
              value={privacyPolicyConsent ? <AcceptanceText /> : <RejectionText />}
              originalValue={initialPrivacyPolicyConsent ? <AcceptanceText /> : <RejectionText />}
            />
          )}
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={previousRoute ? () => navigate(previousRoute) : undefined}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
